module.exports = __webpack_public_path__ + "img/google-play-simple-white.da17198c.svg";